import { Injectable } from '@angular/core';

@Injectable()
export class DataRevisionIndicator {

    public get subjectDataRevisionMessage() {
        return 'Subject data change occurred';
    }

    public get visitDataRevisionMessage() {
        return 'Visit data change occurred';
    }

    public get resultDataRevisionMessage() {
        return 'Result data change occurred';
    }
}